var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    {
      staticClass: "pdp",
      class: {
        pb: _vm.magnetProduct,
        "pdp--sidebar-active":
          _vm.settings.recommendationsSidebarCollection.length &&
          _vm.customFields.d2_product_widget_enabled
      }
    },
    [
      _c("product-breadcrumbs", {
        attrs: { product: _vm.product, collection: _vm.collection }
      }),
      _c("div", { staticClass: "pdp__main" }, [
        _c(
          "div",
          { staticClass: "pdp__main-width-container" },
          [
            _c(
              "product-gallery",
              _vm._b(
                {
                  attrs: {
                    "logo-badge": _vm.product.logoBadge
                      ? _vm.product.logoBadge
                      : undefined
                  },
                  model: {
                    value: _vm.variant,
                    callback: function($$v) {
                      _vm.variant = $$v
                    },
                    expression: "variant"
                  }
                },
                "product-gallery",
                _vm.$props,
                false
              )
            ),
            _c(
              "div",
              {
                staticClass: "product-form-detail-container side-padded-mobile"
              },
              [
                _c(
                  "product-form",
                  _vm._b(
                    {
                      attrs: {
                        "selected-magnet-variant": _vm.selectedMagnetVariant,
                        prices: _vm.prices,
                        "atc-cta-class": _vm.settings.atcCtaClass,
                        "display-vendor": _vm.displayVendor
                      },
                      on: {
                        selectedMagnetChange: function(val) {
                          return (_vm.selectedMagnetVariant = val)
                        }
                      },
                      model: {
                        value: _vm.variant,
                        callback: function($$v) {
                          _vm.variant = $$v
                        },
                        expression: "variant"
                      }
                    },
                    "product-form",
                    _vm.$props,
                    false
                  )
                ),
                _c(
                  "product-details",
                  _vm._b(
                    {
                      staticClass: "pdp__accordions",
                      model: {
                        value: _vm.variant,
                        callback: function($$v) {
                          _vm.variant = $$v
                        },
                        expression: "variant"
                      }
                    },
                    "product-details",
                    _vm.$props,
                    false
                  )
                )
              ],
              1
            ),
            _vm.settings.recommendationsSidebarCollection.length &&
            _vm.customFields.d2_product_widget_enabled
              ? _c("product-recommendations-sidebar", {
                  attrs: {
                    products: _vm.settings.recommendationsSidebarCollection,
                    product: _vm.product,
                    settings: _vm.settings
                  }
                })
              : _vm._e()
          ],
          1
        )
      ]),
      !_vm.hideValueProps
        ? _c("product-value-props", {
            staticClass: "pdp__value-props",
            attrs: {
              schema: {
                settings: _vm.transformedValuePropsSettings,
                blocks: _vm.settings.valueProps.blocks
              }
            }
          })
        : _vm._e(),
      _vm.settings.upsellImg
        ? _c("div", { staticClass: "global-product-info-section" }, [
            _c(
              "div",
              {
                staticClass: "global-product-info-section__background",
                style: {
                  "background-image": "url(" + _vm.settings.upsellImg + ")"
                }
              },
              [
                _c(
                  "h2",
                  {
                    staticClass: "global-product-info-section__heading",
                    style: { color: _vm.settings.upsellHeadingColor }
                  },
                  [_vm._v(_vm._s(_vm.settings.upsellHeading))]
                )
              ]
            )
          ])
        : _vm._e(),
      _vm.customFields.show_banner
        ? _c(
            "div",
            { staticClass: "pdp__banner pdp--side-padded-mobile" },
            [
              _c("about-image-banner-block", {
                attrs: { block: _vm.bannerData }
              })
            ],
            1
          )
        : _vm._e(),
      _vm.customFields["show_5050"]
        ? _c(
            "div",
            { staticClass: "pdp__tech-specs" },
            [
              _c(
                "product-tech-specs",
                _vm._b(
                  { attrs: { "v-model": _vm.variant } },
                  "product-tech-specs",
                  _vm.$props,
                  false
                )
              )
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        { staticClass: "pdp__collections-linear" },
        [
          _c("super-collection-linear", {
            class: _vm.featuredCollectionsSettings.background,
            attrs: { settings: _vm.featuredCollectionsSettings }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }